import React from "react";
import "../../Css/HomePage/HomeMap.css";
import icons01 from "../../Images/Home-Contact/icon05.png";
import icons02 from "../../Images/Home-Contact/icon06.png";
import { Slide } from "react-awesome-reveal";

const HomeMap = (() => {
    return (
        <>
        
            <section className="container-fluid home-section-map">
            <div className="">
                <div className="row home-contact-row">
                    <div className="col-12 col-lg-6 home-contact-col">
                        <Slide>
                        <div className="home-section-map-main-con">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15088.760675331774!2d73.3268149!3d19.0113401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7f08adbbef231%3A0xbb02d6172ec767d6!2sSeema&#39;s%20Resort%20%26%20Restaurant%20Neral-Karjat!5e0!3m2!1sen!2sin!4v1733472183073!5m2!1sen!2sin" width="100%" height="100%" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        </Slide>
                    </div>
                    <div className="col-6 col-lg-3 home-contact-col">
                        <div className="home-section-map-contact-details-main-con">
                            <div className="home-section-map-contact-details-con">
                                <div className="home-section-map-contact-details-image-main-con">
                                    <img src={icons01} alt="icons01"/>
                                </div>
                                <h2>Contact Us</h2>
                                <div className="home-section-map-contact-details-1-main-con">
                                    <h3>Reservation :</h3>
                                    <a>7745852323</a>
                                </div>
                                <div className="home-section-map-contact-details-1-main-con">
                                    <h3>Booking :</h3>
                                    <a>7745852323</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-3 home-contact-col">
                    <div className="home-section-map-contact-details-main-con">
                            <div className="home-section-map-contact-details-con2">
                                <div className="home-section-map-contact-details-image-main-con">
                                    <img src={icons02} alt="icons01"/>
                                </div>
                                <h2>Drop a Line</h2>
                                <div className="home-section-map-contact-details-1-main-con">
                                    <h3>Information :</h3>
                                    <a>seemaresort@gmail.com</a>
                                </div>
                                <div className="home-section-map-contact-details-1-main-con">
                                    <h3>Information :</h3>
                                    <a>seemaresort@gmail.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </section>
            
        </>
    )
});

export default HomeMap;